import { writable } from 'svelte/store'

let cocktailDefault =  {
    nbPersonnes: 200,
    nbBuveurs: 120,
    nbCoupesByBuveur: 3,
    coupeEnCl: 12.5,
    margeSecurity: 20,
    soupeChamp: 5.5,
    soupeAdjuv1: 4,
    soupeAdjuv2: 1,
    soupeAdjuv3: 2,
    soupeAdjuv4: 0,
    volumeBoutChamp: 0.75,
    volumeBoutAdjuv1: 1,
    volumeBoutAdjuv2: 1,
    volumeBoutAdjuv3: 0.75,
    volumeBoutAdjuv4: 0.75
}



const cocktailObj = JSON.parse(localStorage.getItem('cocktail'));

//console.log('store => ' + JSON.stringify(cocktailObj))

export const cocktailStore = writable(cocktailObj === null ? cocktailDefault : cocktailObj );


cocktailStore.subscribe((value) => {
    localStorage.setItem('cocktail',JSON.stringify(value))
})
